import { InfoPopupStore } from '../../_flux/stores/info_popup_store';
import { InfoPopupDispatcher } from '../../_constants/info_popup';
import { showAction as showRegoLookup } from '../../_flux/actions/rego_lookup_actions';
import { showAction as showVehicleConfigurator } from '../../_flux/actions/vehicle_configurator_actions';
import { hideAction as hideInfoPopup } from '../../_flux/actions/info_popup_actions';

export function onBodyButtonClick() {
    const dispatcher = InfoPopupStore.getState().dispatcher;

    switch (dispatcher) {
        case InfoPopupDispatcher.REGO_LOOKUP:
            hideInfoPopup();
            showRegoLookup();
            break;
        case InfoPopupDispatcher.VEHICLE_CONFIGURATOR:
            hideInfoPopup();
            showVehicleConfigurator();
            break;
        case InfoPopupDispatcher.CATALOG_FILTER_VEHICLE:
            hideInfoPopup();
            break;
        case InfoPopupDispatcher.CHECKOUT_STEP_ORDER:
            hideInfoPopup();
            break;
        case InfoPopupDispatcher.BUY_4_PAY_3:
            hideInfoPopup();
            break;
    }
}
